export default __webpack_public_path__ + "static-front/media/DeleteChecked.423fd01f.svg";